export default function PrivacyPolicy() {
  return (
    <div style={{ maxWidth: "800px", margin: "0 auto", padding: "2rem", fontFamily: "sans-serif", lineHeight: "1.7", color: "#333" }}>
      <h1 style={{ fontSize: "1.8rem", marginBottom: "0.5rem" }}>Privacy Policy</h1>
      <p style={{ color: "#666", marginBottom: "2rem" }}>Last updated: April 2026</p>

      <h2 style={{ fontSize: "1.2rem", marginTop: "1.5rem" }}>1. Who We Are</h2>
      <p>On Purpose Planner is a personal productivity application created by Robert Pendergrast. You can contact us at robert.pendergrastmd@gmail.com.</p>

      <h2 style={{ fontSize: "1.2rem", marginTop: "1.5rem" }}>2. What Data We Collect</h2>
      <p>We collect your name and email address when you sign in using Google OAuth. We also store the tasks and notes you create within the app.</p>

      <h2 style={{ fontSize: "1.2rem", marginTop: "1.5rem" }}>3. How We Use Your Data</h2>
      <p>Your information is used solely to authenticate you and to save and display your personal planner data. We do not use your data for advertising or analytics.</p>

      <h2 style={{ fontSize: "1.2rem", marginTop: "1.5rem" }}>4. Data Sharing</h2>
      <p>We do not sell, trade, or share your personal information with third parties. Your data is stored securely using Google Firebase/Firestore.</p>

      <h2 style={{ fontSize: "1.2rem", marginTop: "1.5rem" }}>5. Third-Party Services</h2>
      <p>This app uses Google Firebase for authentication and data storage, and Google OAuth for sign-in. These services are governed by <a href="https://policies.google.com/privacy" target="_blank" rel="noreferrer" style={{ color: "#2563eb" }}>Google's Privacy Policy</a>.</p>

      <h2 style={{ fontSize: "1.2rem", marginTop: "1.5rem" }}>6. Data Retention & Deletion</h2>
      <p>Your data is retained as long as you have an active account. To request deletion of your account and all associated data, please email robert.pendergrastmd@gmail.com.</p>

      <h2 style={{ fontSize: "1.2rem", marginTop: "1.5rem" }}>7. Changes to This Policy</h2>
      <p>We may update this policy occasionally. Continued use of the app after changes constitutes acceptance of the updated policy.</p>
    </div>
  );
}
